<div class="row g-4">
  <app-harbour-dues-rotterdam-pro-forma-table header="Vessel" [data]="vesselData()">
    <ng-template proFormaColumn="Gross tonnage" [type]="ColumnType.VALUE" let-vessel>
      {{ vessel.grossTonnage | number: '1.0-0' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE" let-vessel>
      {{ vessel.vesselTypeTariff | currency: currency() : '' : '1.3-3' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL" let-vessel>
      {{ vessel.vesselTotal | currency: currency() : '' : '1.2-3' : 'nl' }}
    </ng-template>
    
    <ng-template proFormaSubTotal>
      {{ proForma().portDuesProforma?.vesselProforma?.vesselTotal | currency: currency() : 'symbol' : '1.2-3' : 'nl' }}
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <app-harbour-dues-rotterdam-pro-forma-table header="Cargo" [data]="cargoData()">
    <ng-template proFormaColumn="Cargo type" [type]="ColumnType.DESCRIPTION" let-cargo>
      {{ cargo.cargoTypeDescription }}
    </ng-template>
    <ng-template proFormaColumn="Tonnage" [type]="ColumnType.VALUE" let-cargo>
      {{ cargo.tonnage | number: '1.0-0' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE" let-cargo>
      {{ cargo.cargoTariff | currency: currency() : '' : '1.3-3' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL" let-cargo>
      {{ cargo.cargoAmount | currency: currency() : '' : '1.2-3' : 'nl' }}
    </ng-template>

    <ng-template proFormaDiscountLabel>
      <span>Efficiency discount</span>
    </ng-template>
    <ng-template proFormaDiscountValue>
      {{ proForma().portDuesProforma?.cargo?.efficiencyDiscount | currency: currency() : '' : '1.2-3' : 'nl' }}
    </ng-template>

    <ng-template proFormaSubTotal>
      {{ proForma().portDuesProforma?.cargo?.cargoTotal | currency: currency() : 'symbol' : '1.2-3' : 'nl' }}
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <app-harbour-dues-rotterdam-pro-forma-table header="Sustainability" [data]="sustainabilityData()">
    <ng-template proFormaColumn="Gross tonnage" [type]="ColumnType.VALUE" let-sustainability>
      {{ sustainability.grossTonnage | number: '1.0-0' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE" let-sustainability>
      {{ sustainability.sustainabilityTariff | currency: currency() : '' : '1.3-3' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL" let-sustainability>
      {{ sustainability.sustainabilityAmount | currency: currency() : '' : '1.2-3' : 'nl' }}
    </ng-template>

    <ng-template proFormaDiscountLabel>
      <span>ESI discount ({{ proForma().portDuesProforma?.sustainability?.esiPercentage }}%)</span>
    </ng-template>
    <ng-template proFormaDiscountValue>
      {{ proForma().portDuesProforma?.sustainability?.esiDiscount | currency: currency() : '' : '1.2-3' : 'nl' }}
    </ng-template>
    <ng-template proFormaDiscountLabel>
      <span>Green award discount ({{ proForma().portDuesProforma?.sustainability?.greenAwardPercentage }}%)</span>
    </ng-template>
    <ng-template proFormaDiscountValue>
      {{ proForma().portDuesProforma?.sustainability?.greenAwardDiscount | currency: currency() : '' : '1.2-3' : 'nl' }}
    </ng-template>

    <ng-template proFormaSubTotal>
      {{ proForma().portDuesProforma?.sustainability?.sustainabilityTotal | currency: currency() : 'symbol' : '1.2-3' : 'nl' }}
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <app-harbour-dues-rotterdam-pro-forma-table header="Waste disposal" [data]="wasteData()">
    <ng-template proFormaColumn="Fixed base fee" [type]="ColumnType.VALUE" let-waste>
      {{ waste.wasteFixedPart | currency: currency() : '' : '1.3-3' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      +
    </ng-template>
    <ng-template proFormaColumn="Gross tonnage" [type]="ColumnType.VALUE" let-waste>
      {{ waste.grossTonnage | number: '1.0-0' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Operation" [type]="ColumnType.OPERATION">
      &times;
    </ng-template>
    <ng-template proFormaColumn="Rate" [type]="ColumnType.VALUE" let-waste>
      {{ waste.wasteTariff | currency: currency() : '' : '1.3-3' : 'nl' }}
    </ng-template>
    <ng-template proFormaColumn="Amount" [type]="ColumnType.LINE_TOTAL" let-waste>
      {{ waste.wasteSubtotal | currency: currency() : '' : '1.2-3' : 'nl' }}
    </ng-template>

    <ng-template proFormaSubTotal>
      {{ proForma().waste?.wasteTotal | currency: currency() : 'symbol' : '1.2-3' : 'nl' }}
    </ng-template>
  </app-harbour-dues-rotterdam-pro-forma-table>

  <footer class="mt-5 mt-mb-4">
    <dl class="row mb-0">
      <dt class="col-6 col-md-12 mb-md-2 mb-0 fw-regular text-md-end">
        Grand total
      </dt>
        <dd class="col-6 col-md-12 mb-0 fw-regular text-end">
          {{ proForma().proFormaTotal | currency: currency() : 'symbol' : '1.2-3' : 'nl' }}
        </dd>
    </dl>
  </footer>
</div>